import React from 'react'
import * as S from '../styles'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

type SignatureErrorProps = {
  /** Texto no lugar do padrão (ex.: link inválido). */
  message?: React.ReactNode
}

const SignatureError = ({ message }: SignatureErrorProps) => {
  return (
    <S.IconWrapper>
      <ErrorOutlineIcon
        style={{ color: '#CC0000', fontSize: 96, marginBottom: 10 }}
      />
      <S.IconText>
        {message ?? (
          <>
            Não foi possível realizar a assinatura.
            <br />
            Por favor, tente novamente mais tarde.
          </>
        )}
      </S.IconText>
    </S.IconWrapper>
  )
}
export default SignatureError
